import React from "react";
import LoaderSimple from "../../general/loader";
import ReactCardFlip from "react-card-flip";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHoverObserver from "react-hover-observer";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import Docs from "./docs";
import { downloadFolder } from "../../../store/actions/folders/detail";
import { startDownloadData } from "../../../libs/utils";
import { categoryToDesc } from "../../../constants/folders";

const Cards = props => {
  const {
    filterOrder,
    searchValue,
    idToFlip,
    idToPopover,
    onActionClick,
    setIdToPopover,
    setIdToFlip,
    setIdToPreview
  } = props;

  const folders = useSelector(state => state.folders);
  const main = useSelector(state => state.main);
  const foldersDetail = useSelector(state => state.foldersDetail);
  const foldersList = folders.folders;
  const dispatch = useDispatch();

  const editText = useIntl().formatMessage({
    id: "actions.edit"
  });
  const shareText = useIntl().formatMessage({
    id: "actions.share"
  });
  const deleteText = useIntl().formatMessage({
    id: "actions.delete"
  });

  const onDownloadFolder = idFolder => {
    dispatch(downloadFolder(idFolder)).then(res => {
      startDownloadData({ content: res.base64, filename: res.filename });
    });
    return null;
  };

  let cards = [];
  if (folders.isGettingFolders) {
    return (
      <div style={{ marginTop: 50 }}>
        <LoaderSimple />
      </div>
    );
  }
  if (foldersList) {
    let foldersListNew = foldersList;
    switch (filterOrder) {
    case "old":
      foldersListNew.sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
      break;
    case "update_new":
      foldersListNew.sort((a, b) =>
        moment(b.updatedAt || b.createdAt) -
            moment(a.updatedAt || a.createdAt));
      break;
    case "update_old":
      foldersListNew.sort((a, b) =>
        moment(a.updatedAt || a.createdAt) -
            moment(b.updatedAt || b.createdAt));
      break;
    case "az":
      foldersListNew.sort((a, b) => {
        if (a.folderName.toLowerCase() < b.folderName.toLowerCase()) {
          return -1;
        }
        if (a.folderName.toLowerCase() > b.folderName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      break;
    case "za":
      foldersListNew.sort((a, b) => {
        if (b.folderName.toLowerCase() < a.folderName.toLowerCase()) {
          return -1;
        }
        if (b.folderName.toLowerCase() > a.folderName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      break;
    default:
      foldersListNew.sort((a, b) => moment(b.createdAt) - moment(a.createdAt));
      break;
    }
    foldersListNew.map(item => {
      if (
        !searchValue ||
        searchValue === "" ||
        (searchValue &&
          searchValue !== "" &&
          (item.folderName.toLowerCase().indexOf(searchValue.toLowerCase()) >
            -1 ||
            item.refYear
              .toString()
              .toLowerCase()
              .indexOf(searchValue.toLowerCase()) > -1))
      ) {
        cards.push(<div
          key={`Fascicoli-card_${item.id}`}
          id={`Fascicoli-card_${item.id}`}
          className="Fascicoli-card-main"
        >
          <ReactCardFlip isFlipped={item.id === idToFlip}>
            <div className="flip-card-front">
              <div className="Fascicoli-card-root">
                <div className="Fascicoli-card-root-inner">
                  <div className="Fascicoli-card-header title">
                    <div>
                      {item.folderName}
                      {item.availableTo === "owner" && (
                        <Tooltip title="Visibile solo al tuo studio"
                          color={"rgb(0, 80, 117)"}
                        >
                          <FontAwesomeIcon
                            icon={["fal", "minus-hexagon"]}
                            style={{
                              marginLeft: 8,
                              color: "#d82829",
                              fontSize: 12
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    <div>
                      <Tooltip
                        color={"rgb(0, 80, 117)"}
                        trigger="click"
                        visible={item.id === idToPopover}
                        placement={"topLeft"}
                        overlayClassName={"Fascicoli-List-Actions"}
                        title={
                          <div>
                            <div className="Fascicoli-List-Actions-container">
                              {main.myType === "STUDIO" && (
                                <Tooltip title={editText} color={"rgb(0, 80, 117)"}>
                                  <div
                                    className="Fascicoli-List-Actions-action"
                                    onClick={() => {
                                      onActionClick("edit", item.id);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={["far", "edit"]} />
                                  </div>
                                </Tooltip>
                              )}
                              {
                                <Tooltip title={shareText} color={"rgb(0, 80, 117)"}>
                                  <div
                                    className="Fascicoli-List-Actions-action gs-folders-share"
                                    onClick={() => {
                                      onActionClick("share", item.id);
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={["far", "share"]}
                                    />
                                  </div>
                                </Tooltip>
                              }
                              {main.myType === "STUDIO" && (
                                <Tooltip title={deleteText} color={"rgb(0, 80, 117)"}>
                                  <div
                                    className="Fascicoli-List-Actions-action"
                                    onClick={() => {
                                      onActionClick("delete", item.id);
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={["far", "trash"]}
                                    />
                                  </div>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        }
                      >
                        <span
                          id={"Fascicoli-cards-actions-container_" + item.id}
                          onClick={() => setIdToPopover(item.id)}
                          style={{
                            paddingLeft: 10,
                            paddingRight: 10,
                            cursor: "pointer",
                            margin: "0 auto",
                            textAlign: "center"
                          }}
                        >
                          <FontAwesomeIcon
                            id={"Fascicoli-cards-actions_" + item.id}
                            icon={["fal", "ellipsis-v"]}
                            style={{ color: "#0090d1", fontSize: "25px" }}
                          />
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                  <ReactHoverObserver
                    onMouseEnter={() => {
                      if (!idToFlip) {
                        setIdToFlip(item.id);
                      }
                    }}
                  >
                    <div className="Fascicoli-card-body">
                      <div className="Fascicoli-card-body-container card-doc-list">
                        {/* <div className="Fascicoli-card-body-row"><b>Cliente:</b> <span>{company.companies.find(x => x.id === item.itemId).ragioneSociale}</span></div>*/}
                        <div className="Fascicoli-card-body-row">
                          <b>
                            {filterOrder.indexOf("update_") > -1
                              ? <FormattedMessage id="folders.lastUpdate" />
                              : <FormattedMessage id="folders.createdAt" />}
                              :
                          </b>{" "}
                          <span>
                            {moment(filterOrder.indexOf("update_") > -1
                              ? item.updatedAt || item.createdAt
                              : item.createdAt).format("DD/MM/yyyy")}
                          </span>
                        </div>
                        <div className="Fascicoli-card-body-row">
                          <b><FormattedMessage id="folders.type" />:</b>{" "}
                          <span>
                            {categoryToDesc[item.folderCategory]
                              ? <FormattedMessage id={`folders.typology.${categoryToDesc[item.folderCategory]}`} defaultMessage={categoryToDesc[item.folderCategory]} />
                              : <FormattedMessage id="folders.custom" />}
                          </span>
                        </div>
                        <div className="Fascicoli-card-body-row">
                          <b><FormattedMessage id="folders.refYear" />:</b>{" "}
                          <span>{item.refYear}</span>
                        </div>
                      </div>
                    </div>
                  </ReactHoverObserver>
                  <div className="Fascicoli-card-footer gs-folders-download">
                    <div onClick={() => onDownloadFolder(item.id)}>
                      <FontAwesomeIcon icon={["far", "arrow-to-bottom"]} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flip-card-back">
              <div className="Fascicoli-card-root">
                <div className="Fascicoli-card-root-inner">
                  <div
                    className="Fascicoli-card-header"
                    style={{ borderBottom: "1px solid #0090d1" }}
                  >
                    <div style={{ fontSize: 14, color: "#464445" }}>
                      <FormattedMessage id="folders.contains" />:
                    </div>
                    <div>
                      <span
                        id={"Fascicoli-cards-close-container_" + item.id}
                        onClick={() => setIdToFlip()}
                        style={{
                          paddingLeft: 10,
                          paddingRight: 10,
                          cursor: "pointer",
                          margin: "0 auto",
                          textAlign: "center"
                        }}
                      >
                        <FontAwesomeIcon
                          id={"Fascicoli-cards-close" + item.id}
                          icon={["fal", "times-circle"]}
                          style={{ color: "#0090d1", fontSize: "16px" }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="Fascicoli-card-body">
                    <div className="Fascicoli-card-body-container card-doc-list">
                      {foldersDetail.isGettingSubjectiveFolderDetailContent ? (
                        <div style={{ marginTop: 20 }}>
                          <LoaderSimple />
                        </div>
                      ) : (
                        <Docs setIdToPreview={setIdToPreview} />
                      )}
                    </div>
                  </div>
                  <div className="Fascicoli-card-footer gs-folders-download">
                    <div onClick={() => onDownloadFolder(item.id)}>
                      <FontAwesomeIcon icon={["far", "arrow-to-bottom"]} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ReactCardFlip>
        </div>);
      }
      return null;
    });
  }
  return <div className="Fascicoli-list-cards">{cards}</div>;
};

export default Cards;
